<script setup>
import Avatar from "@/components/ui/Avatar.vue";
import {ref, watch} from "vue";
import {useStore} from "vue2-helpers/vuex";

const props = defineProps(['activity']);
const emit = defineEmits(['updateComment', 'deleteComment']);
const store = useStore();

const editMode = ref(false);
const editText = ref();

watch(editMode, value => {
    if (value) {
        editText.value = props.activity.text;
    } else {
        if (editText.value.length && editText.value !== props.activity.text) {
            emit('updateComment', editText.value);
        }
    }
});
</script>

<template>
    <li>
        <figure class="list-comments__image">
            <Avatar
                :username="activity.creator.name"
                :src="activity.creator.avatar"
                :size="39"
            />
        </figure>

        <div class="list-comments__content">
            <header class="list-comments__header">
                <div class="list-comments__header__inner">
                    <h5 class="heading5 heading5--secondary">
                        {{activity.creator.name}}

                        <template v-if="activity.type === 'log'">
                            {{activity.text}}
                        </template>
                    </h5>

                    <time class="list-comments__time">{{activity.created_at}}</time>
                </div>

                <b-dropdown v-if="activity.type === 'comment' && activity.creator.id === store.state.user.id && !editMode" id="edit" text="" class="dropdow--edit">
                    <b-dropdown-item @click.stop="editMode = true">Edit Comment</b-dropdown-item>
                    <b-dropdown-item class="dropdow--edit__delete" @click="emit('deleteComment')">Delete Comment</b-dropdown-item>
                </b-dropdown>
            </header>

            <textarea
                v-if="editMode"
                v-model="editText"
                style="width: 100%"
                v-click-outside="() => { editMode = false }"
                class="comments-section__input pt-2"
            />

            <p v-else-if="activity.type !== 'log'">{{activity.text}}</p>
        </div>
    </li>
</template>

<style scoped>

</style>
